import React, { useCallback, useState, useEffect } from "react";
import styled from "styled-components";
import UnconfiguredComponent from "../common3/UnconfiguredComponent";

const File = styled.div`
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 180px;
  border: 1px solid #eee;
`;

export default (props) => {
  const { extra = {} } = props;

  const { action, label, pdfTempalte } = extra;

  console.log("action", action);

  if (action === "download") {
    if (!label) {
      return <UnconfiguredComponent hint="No label" />;
    }
    return <div>{label}</div>;
  }

  if (action === "generate") {
    if (!label) {
      return <UnconfiguredComponent hint="No label" />;
    }
    if (!pdfTempalte) {
      return <UnconfiguredComponent hint="No template" />;
    }
    return <div>{label}</div>;
  }

  return (
    <React.Fragment>
      <File className="fad fa-file-pdf" />
    </React.Fragment>
  );
};
